(function(){
    'use strict';

    angular.module('elogbooks.user.waste-management', [
    ]);
})();
